import BaseService from '../../services/BaseService';

class FormSubmissionReviewService extends BaseService {}

export default new FormSubmissionReviewService('health_backend','health/form_submission_reviews');